import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";
import IntroLayout from "../CC/IntroLayout";

const NoAccess = () => {
  return (
    <IntroLayout>
      <div className="w-100 d-flex flex-column text-center justify-content-center">
        <span style={{ fontSize: "100px" }} className="font-weight-bold">
          403
        </span>
        <span style={{ fontSize: "25px" }} className="font-weight-bold">
          Forbidden
        </span>
        <span>Accesul la aceasta resursa este restrictionat!</span>
      </div>
    </IntroLayout>
  );
};

const ProtectedRoute = ({ location,menuItems, path, component: Component, ...rest }) => {
  const _hasAccess = path => {
    let _accessGranted = false;

    if(location.pathname === "/login"){
      return true;
    }
    

    for (const header of menuItems) {
      if (_accessGranted) {
        break;
      }

      for (const subHeader of header.content) {
        if (_accessGranted) {
          break;
        }

        for (const menu of subHeader.content) {
          if (`/${menu.to.split("/")[1].split("?")[0]}` === path) {
            _accessGranted = true;
            break;
          }
        }
      }
    }

    return _accessGranted
  };

  return (
    <Route path={path} component={_hasAccess(path) ? Component : NoAccess} />
  );
};

const mapStateToProps = state => ({
  menuItems: state.UserOptions.menuItems
});

export default connect(mapStateToProps, null)(withRouter(ProtectedRoute));
